import * as React from 'react';
import '../style/contact.css';
import '../style/utils.css';
import LeadForm from './leadForm';
import { useResources, useComponentResources } from '../store/resourcesProvider';


const Contact = () => {
    const [showLeadForm, setShowLeadForm] = React.useState(false);

    const resources = useResources();
    const pageRes = useComponentResources('Contact', ['Contact.Title','Contact.Address','Contact.Phone']);

    return (
        <div className="flex-container">
            <div className="column column2">
                        <div className="contact-container">
                            <h1>{pageRes['Contact.Title'] ?? resources.get('Contact.Title','צור קשר')}</h1>
                            <div>{pageRes['Contact.Address'] ?? resources.get('Contact.Address','כתובת: רב צעיר 14 (הצפון הישן), תל אביב.')}</div>
                            <div>{pageRes['Contact.Phone'] ?? resources.get('Contact.Phone','טלפון: 0528271211')}</div>
                </div>
            </div>
            <div className="column column1">
                <LeadForm showDiscountImage={true}
                    onSubmit={() => setShowLeadForm(false)} />
            </div>
            </div>
                    );
                }

                export default Contact;
